import { CountryCodeType } from '@bus/models';
import React from 'react';
import { createOptionsList, createOptionsListFromTranslatedEnum } from '../../../services/common/miscUtils';
import { EircodeFormField } from '../../Fieldset/EircodeFormField';
import { SelectFormField } from '../../Fieldset/SelectFormField';
import { TextInputFormField } from '../../Fieldset/TextInputFormField';
import { CountyEnum } from '../../../types/countyEnum';
import { buildFieldName } from '../../../utils/fieldNameUtils';

export const createFormInputs = (formTranslationKey: string, disabled = false, fieldNamePrefix?: string) => {
  return {
    addressLine1: () => (
      <TextInputFormField
        fieldName={buildFieldName('addressLine1', fieldNamePrefix)}
        labelTranslationKey={`${formTranslationKey}:fields.${'addressLine1'}.label`}
        placeholderTranslationKey={`${formTranslationKey}:fields.${'addressLine1'}.placeholder`}
        isDisabled={disabled}
      />
    ),
    addressLine2: () => (
      <TextInputFormField
        fieldName={buildFieldName('addressLine2', fieldNamePrefix)}
        labelTranslationKey={`${formTranslationKey}:fields.${'addressLine2'}.label`}
        placeholderTranslationKey={`${formTranslationKey}:fields.${'addressLine2'}.placeholder`}
        isDisabled={disabled}
      />
    ),
    addressLine3: () => (
      <TextInputFormField
        fieldName={buildFieldName('addressLine3', fieldNamePrefix)}
        labelTranslationKey={`${formTranslationKey}:fields.${'addressLine3'}.label`}
        placeholderTranslationKey={`${formTranslationKey}:fields.${'addressLine3'}.placeholder`}
        isDisabled={disabled}
      />
    ),
    eirCode: () => (
      <EircodeFormField
        fieldName={buildFieldName('eirCode', fieldNamePrefix)}
        labelTranslationKey={`${formTranslationKey}:fields.${'eirCode'}.label`}
        placeholderTranslationKey={`${formTranslationKey}:fields.${'eirCode'}.placeholder`}
        isDisabled={disabled}
      />
    ),
    town: () => (
      <TextInputFormField
        fieldName={buildFieldName('town', fieldNamePrefix)}
        labelTranslationKey={`${formTranslationKey}:fields.${'town'}.label`}
        placeholderTranslationKey={`${formTranslationKey}:fields.${'town'}.placeholder`}
        isDisabled={disabled}
      />
    ),
    county: () => (
      <SelectFormField
        fieldName={buildFieldName('county', fieldNamePrefix)}
        labelTranslationKey={`${formTranslationKey}:fields.${'county'}.label`}
        optionList={createOptionsList(CountyEnum, formTranslationKey, 'county')}
        isDisabled={disabled}
      />
    ),
    country: () => (
      <SelectFormField
        fieldName={buildFieldName('country', fieldNamePrefix)}
        labelTranslationKey={`${formTranslationKey}:fields.${'country'}.label`}
        optionList={createOptionsListFromTranslatedEnum(CountryCodeType)}
        isDisabled={disabled}
      />
    ),
  };
};
